import { render, staticRenderFns } from "./SalesByVariant.vue?vue&type=template&id=5aa4286e&scoped=true"
import script from "./SalesByVariant.vue?vue&type=script&lang=js"
export * from "./SalesByVariant.vue?vue&type=script&lang=js"
import style0 from "./SalesByVariant.vue?vue&type=style&index=0&id=5aa4286e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa4286e",
  null
  
)

export default component.exports